import IBAN from "iban";
import TypeHelper from './TypeHelper';
import General from '../constants/General';

export default {
    isNotNull(value)
    {
        return value !== null && value !== undefined && value !== '' || 'Bitte Feld ausfüllen';
    },
    requiresSelect(value)
    {
        return value !== null && value !== undefined && String(value).length > 0 || 'Bitte einen Wert wählen';
    },
    isEmail(value)
    {
        return General.EMAIL_REGEX.test(value) || 'Bitte gültige E-Mail Adresse eingeben';
    },
    isInternationalPhone(value)
    {
        return General.PHONE_REGEX.test(value) || 'Bitte eine gültige Telefonnummer eingeben';
    },
    isIban(value)
    {
        return IBAN.isValid(value) || 'Bitte eine gültige IBAN eingeben';
    },
    requiresCheck(value)
    {
        return value !== null && value !== undefined && value === true || 'Bitte Angabe bestätigen';
    },
    isUrl(value)
    {
        let urlRegex = new RegExp('(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$');

        return urlRegex.test(value) || 'Bitte eine gültige URL eingeben.'
    },
    hasMinLength(value, length)
    {
        return !value || value.length >= length || 'Bitte mindestens ' + length + ' Zeichen eingeben';
    },
    isNumeric(value)
    {
        return !value || /^\d+$/.test(value) || 'Bitte nur Zahlen eingeben';
    },
    isBic(value)
    {
        let bicRegex = new RegExp(/^[a-z]{6}[2-9a-z][0-9a-np-z]([a-z0-9]{3}|x{3})?$/i);

        return bicRegex.test(value) || 'Bitte eine gültige BIC eingeben.';
    },
    runValidation(value, validators)
    {
        let validationResult = null;
        for (let i = 0; i < validators.length; i++)
        {
            let validatorResult = validators[i](value);
            validationResult = validatorResult === true ? null : validatorResult;

            //Stop validation when one validator returns errorMessage
            if (TypeHelper.isNotNullOrUndefined(validationResult))
                break;
        }

        return validationResult;
    }
}